import { Theme } from '@mui/material/styles'
import { makeStyles } from '@mui/styles'
import { COLOR_PRIMARY } from '../../routes/color-constants'

export const useFormBuilderStyles = makeStyles((theme: Theme) => ({
  root: {
    width: '100%',
  },

  // ── Cabecera del FormBuilder (nombre + número Odoo) ──────────────────────
  headerFields: {
    display: 'flex',
    gap: theme.spacing(2),
    marginBottom: theme.spacing(4),
  },

  // ── Sección (Datos del paciente / Datos de la muestra) ───────────────────
  sectionCard: {
    backgroundColor: '#e3e3e3',
    borderRadius: '15px',
    padding: theme.spacing(3),
    marginBottom: theme.spacing(4),
  },
  sectionHeader: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: theme.spacing(2),
  },
  sectionTitle: {
    color: COLOR_PRIMARY,
    fontSize: '20px',
    margin: '0 0 0 10px',
    fontWeight: 600,
  },

  // ── Etiqueta de subsección (CAMPOS OBLIGATORIOS / CAMPOS ADICIONALES) ────
  subsectionLabel: {
    color: theme.palette.grey['700'],
    fontWeight: 700,
    marginBottom: `${theme.spacing(1.5)} !important`,
    textTransform: 'uppercase' as const,
    fontSize: '0.72rem',
    letterSpacing: '0.08em',
  },

  // ── Filas de campos fijos (bloqueados) ───────────────────────────────────
  fixedRow: {
    backgroundColor: '#ffffff',
    borderRadius: '10px',
    padding: theme.spacing(2),
    marginBottom: theme.spacing(1.5),
    border: '1px solid #d0d0d0',
  },

  // ── Tarjeta de fila editable ─────────────────────────────────────────────
  rowCard: {
    backgroundColor: '#ffffff',
    borderRadius: '10px',
    padding: theme.spacing(2),
    marginBottom: theme.spacing(2),
    border: '1px solid #d0d0d0',
  },
  rowHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: theme.spacing(1.5),
    paddingBottom: theme.spacing(1),
    borderBottom: '1px solid #e3e3e3',
  },
  rowLabel: {
    fontSize: '0.875rem',
    fontWeight: 700,
    color: theme.palette.grey['700'],
  },
  rowActions: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(0.5),
  },

  // ── Contenedor flex de items dentro de una fila ──────────────────────────
  itemsRow: {
    display: 'flex',
    gap: theme.spacing(2),
    flexWrap: 'wrap' as const,
  },

  // ── Tarjeta individual de campo editable ─────────────────────────────────
  itemCard: {
    flex: '1 1 0%',
    minWidth: 260,
    backgroundColor: '#f8f8f8',
    borderRadius: '10px',
    padding: theme.spacing(2),
    border: '1px solid #e3e3e3',
    position: 'relative' as const,
  },
  itemHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: theme.spacing(1),
  },
  itemFieldGroup: {
    display: 'flex',
    gap: theme.spacing(1),
    marginBottom: theme.spacing(1),
    alignItems: 'center',
    '& > *:first-child': { flex: 1 },
  },

  // ── Caja de opciones (select/radio/multiselect) ──────────────────────────
  optionsBox: {
    marginTop: theme.spacing(1),
    padding: theme.spacing(1.5),
    backgroundColor: '#e3e3e3',
    borderRadius: '8px',
    border: '1px solid #d0d0d0',
  },

  // ── Divisor entre secciones fijas y adicionales ──────────────────────────
  divider: {
    marginTop: `${theme.spacing(2.5)} !important`,
    marginBottom: `${theme.spacing(2.5)} !important`,
    borderColor: '#d0d0d0 !important',
  },

  // ── Estado vacío (sin campos adicionales) ────────────────────────────────
  emptyState: {
    color: theme.palette.grey['600'],
    fontStyle: 'italic',
    marginBottom: `${theme.spacing(2)} !important`,
    padding: `${theme.spacing(2)} !important`,
    textAlign: 'center' as const,
    border: '1px dashed #b5b5b5',
    borderRadius: '10px',
    backgroundColor: '#f0f0f0',
  },

  // ── Botón "Añadir fila" ──────────────────────────────────────────────────
  addRowBtn: {
    marginTop: `${theme.spacing(1)} !important`,
    color: `${COLOR_PRIMARY} !important`,
    borderColor: `${COLOR_PRIMARY} !important`,
    '&:hover': {
      borderColor: '#0099c2 !important',
      backgroundColor: 'rgba(0, 184, 226, 0.06) !important',
    },
  },

  // ── Botones primario / secundario (alineados con Application.styles) ──────
  button: {
    color: `${theme.palette.common.white} !important`,
    background: `${COLOR_PRIMARY} !important`,
    border: '0 !important',
    '&:hover': {
      background: '#0099c2 !important',
      opacity: 0.9,
    },
    '&:disabled': {
      background: `${theme.palette.grey['400']} !important`,
    },
  },
  buttonSecondary: {
    color: `${theme.palette.common.white} !important`,
    background: `${theme.palette.grey['700']} !important`,
    border: '0 !important',
    '&:hover': {
      background: `${theme.palette.grey['600']} !important`,
      opacity: 0.9,
    },
  },

  // ── Barra de acciones inferior ───────────────────────────────────────────
  actions: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(6),
    gap: theme.spacing(2),
  },

  // ── Confirmación de borrado inline ───────────────────────────────────────
  deleteConfirm: {
    marginTop: theme.spacing(1),
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    padding: theme.spacing(1),
    backgroundColor: '#fff5f5',
    borderRadius: '8px',
    border: '1px solid #ffcdd2',
  },
}))
